export default __webpack_public_path__ + "static/media/sport.2821ec1d.jpg";